import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define ProfileSettings interface
interface ProfileSettingsState { 
    participantAdminProfile: string; // New field to differentiate participant/admin
}

// Initial state
const initialState: ProfileSettingsState = { 
    participantAdminProfile: "", // Default empty
};

// Create Redux slice
const participantAdminProfileSlice = createSlice({
    name: 'participantAdminProfile',
    initialState,
    reducers: {
        setParticipantAdminProfile: (state, action: PayloadAction<Partial<ProfileSettingsState>>) => {
            return { ...state, ...action.payload };
        },
        resetParticipantAdminProfile: () => initialState,
    },
});

// Export actions and reducer
export const { setParticipantAdminProfile, resetParticipantAdminProfile } = participantAdminProfileSlice.actions;
export default participantAdminProfileSlice.reducer;
